<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/ajouter-organisation"
        >
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Ajouter
        </router-link>
        <!-- <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
        >
          Exporter
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button> -->
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un menu"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form> 
        <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block"
          type="button"
        >
          <i class="flaticon-dots"></i>
        </button> 
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <!-- <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
               Icone
              </th> -->
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
               Titre
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
               Organisation Parent
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Description
              </th>
              <th
                scope="col"
                class="text-uppercase f w-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
              >ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="org in organisations" :key="org.id">
              <tr>
                <td>{{ truncateText(org.titre ,30)}}</td>
                <td>{{ truncateText(org.organisation ? org.organisation.titre : '-' ,30)}}</td>
                <td>{{ truncateText(org.description, 15)}}</td>
                <td>
                  <div class="dropdown">
                    <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                    </span>
                    <ul class="dropdown-menu">
                      <li>
                        <router-link :to="{ name: 'EditOrganisationPage', params: { id: org.id } }" class="dropdown-item d-flex align-items-center">
                          <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>Modifier
                        </router-link>
                      </li>
                      <li>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="deleteOrganisation(org.id)">
                          <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>Supprimer
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>

            
            </template>
          </tbody>

        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref} from "vue";
import Swal from "sweetalert2";
import ApiService from "../../services/ApiService";
import { suppression, error, getUrlApiForFiles } from "../../utils/utils";
import PaginationComponent from '../../components/Utilities/Pagination.vue';
import JwtService from "../../services/JwtService";
import { Organisation } from "@/models/Organisation";

export default defineComponent({
  name: "ListeOrganisation",
  components: {
    PaginationComponent
  },
  setup(){
    onMounted(() => {
      getAllOrganisation();
    });

    const organisations = ref<Array<Organisation>>([]);   
    const organisation = ref<Organisation>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllOrganisation(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher() {
      getAllOrganisation(page.value, limit.value, searchTerm.value);
    }

    function getAllOrganisation(page = 1, limi = 10, searchTerm = "") {
      return ApiService.get(
        `/organisations?page=${page}&limit=${limi}&mot=${searchTerm}&`
      )
        .then(({ data }) => {
          organisations.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }


    //  function rechercher(){
    //   getAllAlaUne(page.value, limit.value, searchTerm.value );
    // }

    // END PAGINATE


      
  const deleteOrganisation = async (id: number) => {
  const result = await Swal.fire({
    title: 'Confirmation',
    text: 'Voulez-vous vraiment supprimer cette organisation ?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Supprimer',
    cancelButtonText: 'Annuler',
    reverseButtons: true,
    confirmButtonColor: '#4CAF50',
    cancelButtonColor: '#FF4D4D',
    width: '350px',
    focusCancel: true
  })

  // Si l'utilisateur annule
  if (!result.isConfirmed) {
    return
  }

  // Si l'utilisateur confirme
  try {
    const { data } = await ApiService.delete(`/organisation/${id}`)

    // Retirer le menu localement
    organisations.value = organisations.value.filter(organisation => organisation.id !== id)

    // Toast succès
    Swal.fire({
      text: data.message || 'Menu supprimé avec succès',
      toast: true,
      icon: 'success',
      position: 'top-right',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true
    })

  } catch (err: any) {
      Swal.fire({
        text: err.response?.data?.message || "Erreur serveur",
        icon: "error",
      })
    }
}

    function truncateText(text: string, maxLength: number): string {
        if (!text) return ''
        return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
    }
  
    return {  
    organisation,
     organisations,
     getAllOrganisation,
     truncateText,
     suppression,
     page,  rechercher,
      searchTerm,
     totalPages,
     limit,
     totalElements, 
     handlePaginate,
     deleteOrganisation,
  };
  }
  });
</script>